var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#303030;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#303030;}\n\t.st2{fill:#808285;}\n\t.st3{fill:#58595B;}\n\t.st4{fill:#BCBEC0;}\n\t.st5{fill:#6D6E71;}\n\t.st6{fill:#E6E7E8;}\n\t.st7{fill:#939598;}\n\t.st8{fill:#414042;}\n\t.st9{fill:#444444;}\n\t.st10{fill:#585959;}\n\t.st11{fill:#6D6D6D;}\n\t.st12{fill:#818182;}\n\t.st13{fill:#959696;}\n\t.st14{fill:#A9AAAB;}\n\t.st15{fill:#BEBEBF;}\n\t.st16{fill:#D2D3D4;}\n\t.st17{fill:none;stroke:#303030;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Padding__x26__Artboard"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.8,29.35c-0.01-0.2-0.01-0.35-0.01-0.45c0-0.58,0.08-1.09,0.25-1.51c0.12-0.32,0.32-0.64,0.59-0.97      c0.2-0.24,0.56-0.58,1.07-1.04c0.52-0.45,0.85-0.82,1-1.09c0.15-0.27,0.23-0.56,0.23-0.88c0-0.58-0.23-1.09-0.68-1.52      c-0.45-0.44-1.01-0.66-1.66-0.66c-0.63,0-1.16,0.2-1.59,0.6c-0.42,0.4-0.7,1.02-0.83,1.86l-1.53-0.18      c0.14-1.13,0.55-1.99,1.23-2.6c0.68-0.6,1.58-0.9,2.7-0.9c1.18,0,2.13,0.32,2.83,0.97c0.71,0.64,1.06,1.42,1.06,2.34      c0,0.53-0.12,1.02-0.37,1.46c-0.25,0.45-0.73,0.99-1.45,1.63c-0.48,0.43-0.8,0.75-0.95,0.95c-0.15,0.2-0.26,0.44-0.33,0.7      c-0.07,0.26-0.11,0.69-0.12,1.29H22.8z M22.71,32.33v-1.69h1.69v1.69H22.71z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.14,15.1v22.74c0,0.77-0.62,1.39-1.39,1.39H14.25c-0.77,0-1.39-0.62-1.39-1.39V10.17    c0-0.77,0.62-1.39,1.39-1.39h13.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "27.46,8.78 35.14,15.1 27.46,15.1   "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNotFound);
export default __webpack_public_path__ + "static/media/file-not-found.7f33411d95a66bd40d47d358599e0a49.svg";
export { ForwardRef as ReactComponent };